import {
	type UseMutationOptions,
	useMutation,
	useQueryClient
} from '@tanstack/react-query'
import { httpAcceptQueueListing } from '@/features/luxe-submissions/http/luxe-submissions.http'
import { errorHandler } from '@/helpers/utils'
import { QUEUE_COUNTS_QUERY_KEY } from './use-get-queue-counts'
import { QUEUE_LISTING_DETAILS_QUERY_KEY } from './use-get-queue-listing-details'
import { QUEUE_LISTINGS_QUERY_KEY } from './use-get-queue-listings'
import { VISUAL_VETTING_LISTINGS_QUERY_KEY } from './use-get-visual-vetting-listings'

export const useAcceptQueueListing = (
	listingId: string,
	options?: Omit<UseMutationOptions<unknown, unknown>, 'mutationFn'>
) => {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: () => httpAcceptQueueListing(listingId),
		...options,
		onSuccess: (...args) => {
			queryClient.invalidateQueries({
				queryKey: [QUEUE_LISTINGS_QUERY_KEY]
			})
			queryClient.invalidateQueries({
				queryKey: [QUEUE_COUNTS_QUERY_KEY]
			})
			queryClient.invalidateQueries({
				queryKey: [VISUAL_VETTING_LISTINGS_QUERY_KEY]
			})
			queryClient.invalidateQueries({
				queryKey: [QUEUE_LISTING_DETAILS_QUERY_KEY, { listingId }]
			})
			options?.onSuccess?.(...args)
		},
		onError: (error, variables, onMutateResult, context) => {
			errorHandler(error)
			options?.onError?.(error, variables, onMutateResult, context)
		}
	})
}
